var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.173,
    height: 62.538,
    viewBox: "0 0 78.173 62.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "photo",
    d: "M26.058,18.24a7.785,7.785,0,0,1-7.817,7.817,7.785,7.785,0,0,1-7.817-7.817,7.785,7.785,0,0,1,7.817-7.817,7.785,7.785,0,0,1,7.817,7.817ZM67.75,33.875v18.24H10.423V44.3L23.452,31.269l6.514,6.514L50.812,16.937ZM71.658,5.212H6.514a1.32,1.32,0,0,0-1.3,1.3V56.024a1.32,1.32,0,0,0,1.3,1.3H71.658a1.32,1.32,0,0,0,1.3-1.3V6.514a1.32,1.32,0,0,0-1.3-1.3Zm6.514,1.3V56.024a6.532,6.532,0,0,1-6.514,6.514H6.514a6.273,6.273,0,0,1-4.6-1.913A6.273,6.273,0,0,1,0,56.024V6.514a6.273,6.273,0,0,1,1.913-4.6A6.273,6.273,0,0,1,6.514,0H71.658a6.273,6.273,0,0,1,4.6,1.913,6.273,6.273,0,0,1,1.913,4.6Z",
    fill: "#acacb9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.4728a432b0908634dab7b5a2b23ea0ad.svg";
export { ForwardRef as ReactComponent };